<template>
  <div v-loading="loading" class="alarmClass">
    <div :style="contentStyle">
      <avue-crud :option="option" :data="data" ref="crud" @on-load="onLoad" :page.sync="page" @refresh-change="onLoad" @cell-click="cellClick"
        :cell-style="cellStyle">
        <template slot-scope="scope" slot="menu" v-if="model !== 'view' && scope.row.status == '1'">
          <el-button type="text" size="small" @click="edit(scope.row)">编辑</el-button>
          <el-button type="text" size="small" @click="refund(scope.row)">退约</el-button>
          <el-button type="text" size="small" @click="renew(scope.row)">续约</el-button>
        </template>
      </avue-crud>

      <hr-dialog :title="dialogTitle" :allowFull="false" width="60%" :visible.sync="dialogVisible" @close="closeDialog">
        <template slot="body">
          <RefundForm :row="formRow" @cancle="recordCancle" v-if="dialogVisible && formModel == 'refund'"
            @success="recordSuccess"></RefundForm>
          <SignForm :model="formModel" :row="formRow" @cancle="recordCancle" v-if="dialogVisible && (formModel == 'edit' || formModel == 'renew' || formModel == 'view')"
            @success="recordSuccess"></SignForm>
        </template>
      </hr-dialog>
    </div>
  </div>
</template>
<script>
// import { getDictionary } from '@/api/common.js';
import SignForm from './components/signForm.vue';
import RefundForm from './components/refundForm.vue';
import { getNursinghome } from '../api/serveItemManage.js';

// import { getStore } from '@/util/store';
import {
  contractList
} from '../api/serveItemManage';
export default {
  components: { SignForm, RefundForm },
  model: {
    prop: 'form',
    event: 'change',
  },
  props: {
    form: {},
    row: {
      default: {},
    },
    nursinghomeId: {},
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      contentStyle: "",
      dialogTitle: '',
      dialogVisible: false,
      data: [],
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      nursinghomeIdList: [],
      option: {
        index: true,
        indexLabel: '#',
        height: 'auto',
        calcHeight: 'auto',
        align: 'left',
        menu: this.model != 'view',
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          {
            label: '合同编码',
            prop: 'code',
            width: 180,
          },
          {
            label: '合同开始日期',
            prop: 'startTime',
            width: 100,
          },
          {
            label: '合同结束日期',
            prop: 'endTime',
            width: 100,
          },
          {
            label: '月份',
            prop: 'monthNum',
          },
          {
            label: '合同总费用',
            prop: 'fee',
            width: 100,
          },
          {
            label: '合同退款金额',
            prop: 'backFee',
            width: 100,
          },
          {
            label: '合同总收款',
            prop: 'totalPayAmount',
            width: 100,
          },
          {
            label: '是否包房',
            prop: 'isCharteredRoom',
            dataType: 'string',
            dicUrl: '/api/blade-system/dict/dictionary?code=yes_no',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            }
          },
          {
            label: '床位',
            prop: 'bedName',
          },
          {
            label: '退约日期',
            prop: 'leaveDate',
            width: 100,
          },
          {
            label: '合同状态',
            prop: 'status',
            dataType: 'string',
            dicUrl: '/api/blade-system/dict/dictionary?code=nursinghome_contract_status',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            }
          },
        ],
      },
    };
  },
  created() {
    // this.initData();
    getNursinghome().then((res) => {
        this.nursinghomeIdList = res.data;
      });
  },
  mounted() {
    this.calcHeight();
  },
  // activated() {
  //   this.$refs.crud.doLayout();
  // },
  watch: {},
  methods: {
    calcHeight() {
      let bodyHight = document.body.clientHeight;
      let contentHeight = bodyHight - 340;
      this.contentStyle = 'max-height:' + contentHeight + 'px; overflow-y: scroll;overflow-x: hidden;';
    },
    recordSuccess() {
      this.dialogVisible = false;
      this.dialogTitle = ''
      this.onLoad();
    },
    recordCancle() {
      this.dialogTitle = ''
      this.dialogVisible = false;
    },

    closeDialog () {
      console.log('close');
      // this.formModel = '';
      // this.formRow = {};
      // this.dialogTitle = ''
      // this.dialogVisible = false;
    },

    refund(row) {
      this.formModel = 'refund';
      this.dialogTitle = '退约'
      this.formRow = row;
      this.dialogVisible = true;
    },
    edit(row) {
      console.log('open edit');
      this.formModel = 'edit';
      this.dialogTitle = '编辑'
      this.nursinghomeIdList.forEach(ele => {
        if (row.nursinghomeId === ele.id) {
          row.nursinghomeName = ele.name;
        }
      });
      this.formRow = row;
      this.dialogVisible = true;
    },
    renew(row) {
      console.log('open renew');
      this.formModel = 'renew';
      this.dialogTitle = '续约'
      this.formRow = row;
      this.dialogVisible = true
    },
    cellClick(row, column) {
      if (column.label === '合同编码') {
        console.log(row);
          this.dialogTitle = '查看'
          this.formModel = 'view';
          this.formRow = row;
          this.dialogVisible = true;
      }
    },
    cellStyle({column}) {
      if (column.label === '合同编码') {
        return {
          color: '#409eff',
          cursor: 'pointer',
        };
      }
    },
    onLoad() {
      this.loading = true;
      contractList(
        Object.assign(
          {},
          { current: this.page.currentPage, size: this.page.pageSize, nursinghomeId: this.row.nursinghomeId, elderlyId: this.row.id }
        )
      )
        .then(({ data }) => {
          this.data = data.records;
          this.data.forEach(ele => {
            ele.startTime = ele.startTime ? ele.startTime.split(' ')[0] : '';
            ele.endTime = ele.endTime ? ele.endTime.split(' ')[0] : '';
            ele.leaveDate = ele.leaveDate ? ele.leaveDate.split(' ')[0] : '';
          });
          this.page.total = data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
      // this.data = [{
      //   id: '1',
      //   code: 'HT20240620123456310001',
      //   startTime: '2024-06-20',
      //   endTime: '2025-06-20',
      //   yearMonth: '12',
      //   totalPrice: '2400',
      //   refundAmount: '500',
      //   totalPayAmount: '1900',
      //   isPrivateRoom: '1',
      //   bedName: '0001',
      //   refundDate: '2024-06-29',
      //   status: '1',
      // }]
    },
    initData() {

    },
    saveRecord() {
      let result = false;
      this.$refs['formRef'].validate((valid) => {
        console.log('子', valid);
        result = valid;
      });
      return result;
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
<style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

::v-deep .el-col-8 {
  height: 54px;
}
</style>
